import { render, staticRenderFns } from "./InfoButton.vue?vue&type=template&id=23613b05&scoped=true"
import script from "./InfoButton.vue?vue&type=script&lang=js"
export * from "./InfoButton.vue?vue&type=script&lang=js"
import style0 from "./InfoButton.vue?vue&type=style&index=0&id=23613b05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23613b05",
  null
  
)

export default component.exports